import { useEffect,useState } from "react"
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useFetchExistingFiles = (leadID, refreshTrigger = 0) => {
    const [idFileCount,setIdFileCount] = useState(null);
    const [loaFileCount,setLoaFileCount] = useState(null);
    const [othersFileCount,setOthersFileCount] = useState(null);
    const [idFile,SetIdFile] = useState(null);
    const [loaFile,SetLoaFile] = useState(null);
    const [othersFile,SetOthersFile] = useState(null);

    useEffect(() => {
        const fetchExistingFiles = async () => {
          try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_FILES.EXISTING_FILES}/${leadID}`);
            setIdFileCount(result.files_count.id);
            setLoaFileCount(result.files_count.loa);
            setOthersFileCount(result.files_count.misc);
            SetIdFile(result.files.id);
            SetLoaFile(result.files.loa);
            SetOthersFile(result.files.misc);
          } catch (error) {
            console.error("Error fetching existing files:", error);
          }
        };
        fetchExistingFiles();
    }, [leadID, refreshTrigger]);
    return {idFileCount,loaFileCount,othersFileCount,idFile,loaFile,othersFile};
}